<template>
  <div id="home-page">
    <img id="home-page-bcg" v-if="homePageData" :src="homePageData.bcg" />
    <div class="home-page-box">
      <div
        class="home-page-box-item"
        :key="'multibook-type' + index"
        @click="redirectDev(it.name, it.router, it.disable)"
        v-for="(it, index) in homePageData.multibooks"
        :class="{ 'home-page-disable-item': it.disable }"
        :style="[{ width: (100 - 10) / homePageData.multibooks.length + '%' }, it.cssStyle]"
      >
        <img :src="it.bcg" />
      </div>
    </div>
  </div>
</template>
<script>
import home from '../../config/homePage/homePage.js';
export default {
  name: 'home-page',
  props: {
    runBook: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      homePageData: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.name === 'main_book-view' && to.params.runBook) {
      next((vm) => {
        let link = to.params.runBook || '';
        vm.open(link);
        vm.$router.push('/');
      });
    }
    next();
  },
  beforeMount() {
    this.init();
  },
  methods: {
    redirectDev(type, router, disable) {
      if (!disable) {
        if (router && type != 'main_book') {
          this.$store.commit('CHANGE_MULTIBOOK_TYPE', type);
          this.$router.push({ name: router });
        } else if (type === 'main_book') {
          this.$router.push({ name: 'main_book-view', params: { runBook: process.env.MAIN_BOOK_PATH } });
        } else {
          this.$router.push({ name: 'page-view', params: { id: '-1', multibookType: `${type}` } });
        }
      }
    },
    open(link) {
      const path = require('path');
      let fullLink;
      let base;
      if (!process.env.VUE_APP_IS_WEB) {
        if (require('os').platform() === 'win32') {
          console.log('WIN32');
          base = path.win32.resolve();
        } else {
          console.log('LINUX');
          base = path.posix.resolve();
        }
        fullLink = path.join(base, '/../' + link);
        this.$electron.shell.openItem(fullLink);
      } else {
        console.log('THIS IS WEB');
        this.$store.commit('CHANGE_DEMO_ACTIVE', true);
      }
    },
    init() {
      this.homePageData = home;
    },
  },
  computed: {},
};
</script>

<style lang="sass">
$break-large: 1400px
#home-page
  width: 100vw
  height: calc(var(--vh, 1vh)*100)
  background: white
  background-size: cover
  #home-page-bcg
    position: absolute
    width: 100vw
    height: calc(var(--vh, 1vh)*100)
    top: 0
    left: 0
  .home-page-box
    width: 100%
    height: 100%
    display: flex
    flex-direction: row
    position: absolute
    top: 0
    left: 0
    align-items: center
    justify-content: center
    .home-page-box-item
      max-width: 40%
      max-height: 80%
      img
        width: 100%
        height: 100%
        transform: scale(.8)
        transition: .5s
        cursor: pointer
        &:hover
          transform: scale(1)
    .home-page-disable-item
      filter: grayscale(1) !important
      img
        transform: scale(.8) !important
        cursor: auto
        &:hover
          transform: scale(.8) !important
</style>
